import { render } from "./ModuleStatus.vue?vue&type=template&id=5cb6de25"
import script from "./ModuleStatus.vue?vue&type=script&lang=js"
export * from "./ModuleStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/ModuleStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cb6de25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cb6de25', __exports__)) {
    api.reload('5cb6de25', __exports__)
  }
  
  module.hot.accept("./ModuleStatus.vue?vue&type=template&id=5cb6de25", () => {
    api.rerender('5cb6de25', render)
  })

}


export default __exports__